import React, { useEffect, useState } from "react";
import MetaTags from "../../DynamicMetaData/DynamicMetadata";
import Header from "../../components/Header/Header";

const SitemapPage = () => {
  const [sitemapData, setSitemapData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const baseURL = "https://auth.ssccglpinnacle.com/api";

  useEffect(() => {
    fetch(`${baseURL}/sitemap-data`)
      .then((res) => res.json())
      .then((data) => {
        setSitemapData(data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching sitemap data:", err);
        setError(true);
        setLoading(false);
      });
  }, []);

  if (loading) return <p className="text-center py-6">Loading sitemap...</p>;
  if (error)
    return (
      <p className="text-center text-red-600 py-6">
        Error loading sitemap. Please try again later.
      </p>
    );

  return (
    <>
      <Header />
      <MetaTags type="sitemap" />
      <div className="min-h-screen bg-[#F9F9F9] px-4 md:px-12 py-8 text-gray-800">
        <h3 className="text-2xl md:text-3xl font-bold text-center mb-8">
          Sitemap
        </h3>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {Array.isArray(sitemapData) && sitemapData.length > 0 ? (
            sitemapData.map((category, categoryIndex) => (
              <div
                key={categoryIndex}
                className="bg-white shadow p-6 rounded-md"
              >
                <h2 className="text-lg font-semibold mb-3 text-blue-700">
                  {category.category || "Uncategorized"}
                </h2>
                <ul className="space-y-2">
                  {Array.isArray(category.links) &&
                  category.links.length > 0 ? (
                    category.links.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        <a
                          href={link.url || "/"}
                          className="text-blue-500 hover:underline break-words"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {link.title || "Untitled"}
                        </a>
                      </li>
                    ))
                  ) : (
                    <li>
                      <span className="text-gray-500 italic">
                        No links available
                      </span>
                    </li>
                  )}
                </ul>
              </div>
            ))
          ) : (
            <p className="text-center">No sitemap data available.</p>
          )}
        </div>
      </div>
    </>
  );
};

export default SitemapPage;
